import React from 'react';

const PageTitleServicesInside = () => {
    return (
        <section id="page-title" className="page-title-ml content-top-spacing">
            <div className="wrapper">
                <div className="title">
                    <h1 className="large">Strategic Planning</h1>
                </div>

                <div className="title-opacity">
                    <div className="title-opacity-text">Planning</div>
                </div>

                <div className="description spacer p-top-lg">
                    <p>A business consulting agency is involved in the planning, implementation, and education of businesses. We work directly with business owners on developing a business plan, identifying marketing needs and developing the necessary skills for business ownership.</p>
                </div>
            </div>
        </section>
    );
};

export default PageTitleServicesInside;
